(function () {
  'use strict';
  if (window.SketchusNavV26) return;
  window.SketchusNavV26 = true;

  document.documentElement.classList.add('sk-nav-v22', 'sk-nav-v24', 'sk-nav-v25');

  function normalize(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function currentLanguage() {
    return normalize(document.documentElement.lang).indexOf('en') === 0 ? 'en' : 'de';
  }

  function alternateUrl(language) {
    var links = Array.prototype.slice.call(document.querySelectorAll('link[rel="alternate"][hreflang]'));
    var preferred = language === 'en' ? ['en-US', 'en-GB', 'en'] : ['de', 'de-DE'];
    var found;

    preferred.some(function (code) {
      found = links.find(function (link) {
        return normalize(link.getAttribute('hreflang')) === normalize(code);
      });
      return !!found;
    });

    if (!found) {
      found = links.find(function (link) {
        var code = normalize(link.getAttribute('hreflang'));
        return code === language || code.indexOf(language + '-') === 0;
      });
    }

    if (found && found.href) return found.href;
    return language === 'en' ? 'https://sketchus.com/' : 'https://sketchus.de/';
  }

  function primaryPortraitUrl(language) {
    return language === 'en'
      ? 'https://sketchus.com/products/custom-portrait-from-photo'
      : 'https://sketchus.de/products/portrait-zeichnen-lassen';
  }

  function setDesktopOpen(details, open) {
    var summary = details.querySelector(':scope > summary');
    if (open) {
      document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach(function (other) {
        if (other === details) return;
        other.removeAttribute('open');
        var otherSummary = other.querySelector(':scope > summary');
        if (otherSummary) otherSummary.setAttribute('aria-expanded', 'false');
      });
      details.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    } else {
      details.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }
  }

  function enableDesktopHover(details) {
    if (details.dataset.skV26Hover === 'true') return;
    details.dataset.skV26Hover = 'true';
    var headerMenu = details.closest('header-menu');
    var summary = details.querySelector(':scope > summary');
    if (!headerMenu || !summary) return;

    details.addEventListener('toggle', function () {
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    });

    headerMenu.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      setDesktopOpen(details, false);
      summary.focus();
    });

    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var closeTimer;

    headerMenu.addEventListener('mouseenter', function () {
      window.clearTimeout(closeTimer);
      setDesktopOpen(details, true);
    });

    headerMenu.addEventListener('mouseleave', function () {
      closeTimer = window.setTimeout(function () {
        setDesktopOpen(details, false);
      }, 220);
    });
  }

  function updateLinks() {
    var language = currentLanguage();
    document.querySelectorAll('[data-sk-language]').forEach(function (link) {
      var code = link.getAttribute('data-sk-language');
      if (code === 'de' || code === 'en') link.href = alternateUrl(code);
    });

    document.querySelectorAll('.sk-header-portrait-cta, .sk-v25-mobile-cta').forEach(function (link) {
      link.href = primaryPortraitUrl(language);
    });
  }

  function init() {
    document.querySelectorAll('.header__inline-menu details[data-sk-v25-desktop="true"]').forEach(enableDesktopHover);
    updateLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
